import React from 'react'
import './../login/Login.less'
import { Route } from 'react-router-dom'
import {
    Mobile,
    DefaultDevice
} from '../../Utils/mediaQuery'
import PlaceHolder from '../login/PlaceHolder'
import LoginHeader from '../login/LoginHeader'
import LoginFooter from '../login/LoginFooter'

export default function LoginRoute(props) {

    const { showPlaceHolder, ...routeProps } = props;

    return (
        <>
        { showPlaceHolder === false ? 
            <div className="login">
                <div className="login-panel-container-test">
                    <div className="login-panel-test">
                        <LoginHeader />
                        <Route {...routeProps} />
                        <LoginFooter />
                    </div>
                </div>
            </div>
            : <DefaultDevice>
                <>
                    <div className="login">
                        <section className="login-content-container">
                            <PlaceHolder />
                        </section>
                        <div className="login-panel-container">
                            <div className="login-panel">
                                <LoginHeader />
                                <Route {...routeProps} />
                                <LoginFooter />
                            </div>
                        </div>
                    </div>
                </>
            </DefaultDevice>}

            {/* Mobile only UI */}
            <Mobile>
                <>
                    <div className="login-mobile">
                        <div className="login-mobile-overlay" />
                        <header className="login-header">
                            <LoginHeader />
                        </header>
                        <main className="login-panel-container-mobile">
                            <div className="login-panel-mobile">
                                <Route {...routeProps} />
                                <LoginFooter />
                            </div>
                        </main>
                    </div>
                </>
            </Mobile>
        </>
    )
}